import translationEN from "./English.json";
// import translationHI from "./Hindi.json";
import translationSP from "./Spanish.json";
import translationTE from "./Telugu.json";

const translatedLanguages = {
  "en-US": {
    translation: translationEN,
  },
  // hi: {
  //   translation: translationHI,
  // },
  sp: {
    translation: translationSP,
  },
  te: {
    translation: translationTE,
  },
};

export default translatedLanguages;
